// src/features/home/SaleBanner/components/SaleBannerSkeleton.tsx

export const SaleBannerSkeleton = () => {
  return (
    <section className="sale-section padding-bottom">
      <div className="container">
        <div className="sale-section__wrapper">
          <div className="row g-4">
            {/* Skeleton for the first card */}
            <div className="col-lg-6 col-xl-4">
              <div className="sale-card h-100 ">
                <div className="sale-card__inner d-flex align-items-center p-3">
                  <div
                    className="placeholder"
                    style={{ width: '90%', height: '400px', flexShrink: 0 }}
                  ></div>
                </div>
              </div>
            </div>
            {/* Skeleton for the second card */}
            <div className="col-lg-6 col-xl-4">
              <div className="sale-card h-100 ">
                <div className="sale-card__inner d-flex align-items-center p-3">
                  <div
                    className="placeholder "
                    style={{ width: '90%', height: '400px', flexShrink: 0 }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-4">
              <div className="sale-card h-100 ">
                <div className="sale-card__inner d-flex align-items-center p-3">
                  <div
                    className="placeholder "
                    style={{ width: '90%', height: '400px', flexShrink: 0 }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
